import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserState {
    name: string;
    message: string;
    email: string;

    nameIsError: boolean;
    messageIsError: boolean;
    emailIsError: boolean;

    displayForm: boolean;
    displaySubmittedMessage: boolean;
}

const initialState: UserState  = {
    name: "",
    message: "",
    email: "",

    nameIsError: false,
    messageIsError: false,
    emailIsError: false,

    displayForm: true,
    displaySubmittedMessage: false,
};

const user = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setName: (state, action: PayloadAction<string>) => {
      state.name = action.payload;
    },
    setMessage: (state, action: PayloadAction<string>) => {
        state.message = action.payload;
    },
    setEmail: (state, action: PayloadAction<string>) => {
        state.email = action.payload;
    },
    setNameIsError: (state, action: PayloadAction<boolean>) => {
        state.nameIsError = action.payload;
    },
    setEmailIsError: (state, action: PayloadAction<boolean>) => {
        state.emailIsError = action.payload;
    },
    setMessageIsError: (state, action: PayloadAction<boolean>) => {
        state.messageIsError = action.payload;
    },
    setDisplayForm: (state, action: PayloadAction<boolean>) => {
        state.displayForm = action.payload;
    },
    setDisplaySubmittedMessage: (state, action: PayloadAction<boolean>) => {
        state.displaySubmittedMessage = action.payload;
    },
  },
});

export const { setName, setMessage, setEmail, setNameIsError, setEmailIsError, setMessageIsError, setDisplayForm, setDisplaySubmittedMessage } = user.actions;
const userReducer  = user.reducer
export default userReducer;